module.exports = __webpack_public_path__ + "img/caution.2ec00bac.svg";